import type { CuratedStory, Image, ZoneColumnCombo } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

interface SingleStoryImageLeftIntegrityProps {
    items?: CuratedStory[];
    image?: Image;
    renderingLocation?: ZoneColumnCombo;
}

export default function integrityCheck({
    items = [],
    image,
    renderingLocation,
}: SingleStoryImageLeftIntegrityProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly(items));

    if (items?.length) {
        const [content] = items;

        const { type, byline, image: contentImage } = content;

        if (!image?.baseUrl && !contentImage?.baseUrl) {
            messages.push("Missing image baseUrl");
        }

        if (
            type !== "article" &&
            renderingLocation !== "rightRail" &&
            !byline
        ) {
            messages.push("Missing byline");
        }
    }

    return messages;
}
